import { PlusOutlined } from "@ant-design/icons";
import { couponApi } from "@api";
import {
  ComponentPagination,
  SearchFilter,
  SelectedFilter,
  SharedButton,
  StyledListPage,
  ComponentHeader,
  StyledInnerListPage,
  SharedIconButton,
  PlusIcon,
} from "@components";

import { PATH_CREATE_COUPON_FAMILY, couponFilter, enumFilter, initPage } from "@configs";
import { ICoupon, IFormExportValues, IPagination } from "@interfaces";
import { CouponTable } from "@modules";
import { selectApp, setLoading } from "@redux";
import { useNotify } from "@utils";
import { Space, Tooltip } from "antd";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import { ExportSidebar } from "./Export";

export const PageListCoupon = () => {
  // hook
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const history = useHistory();
  const { success, error } = useNotify();
  const { mobile } = useSelector(selectApp);
  // state
  const [page, setPage] = useState<IPagination>(initPage);
  const [total, setTotal] = useState<number>(0);
  const [data, setData] = useState<ICoupon[]>([]);
  const [filters, setFilters] = useState<enumFilter | string>("");
  const [text, setText] = useState<string>("");
  const [date, setDate] = useState<string[]>([]);

  useEffect(() => {
    fetchCoupon();
  }, [page, text, date]);

  const fetchCoupon = async () => {
    try {
      dispatch(setLoading(true));
      const res = await couponApi.coupons({
        page: page.page,
        limit: page.limit,
        searchColumn: filters,
        search: text,
        startDate: date[0],
        endDate: date[1],
      });
      setData(res.data?.data);
      setTotal(res.data?.nTotal);
      success(t("message.fetch.success"));
    } catch (err: any) {
      error(t("message.fetch.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handlePagination = (current: number, size: number) => {
    console.log(current);
    setPage({ ...page, page: current, limit: size });
  };

  const goToCreate = () => history.push(PATH_CREATE_COUPON_FAMILY);
  const changeFilter = (value: string) => {
    setText("");
    setFilters(value);
  };
  const searchText = (value: string) => setText(value);
  const handleClearSearch = () => {
    setText("");
    setFilters("");
  };
  const handleExport = async (payload: IFormExportValues) => {
    try {
      dispatch(setLoading(true));
      await couponApi.exportCoupons(payload);
      success(t("message.export.success"));
    } catch (err: any) {
      error(t("message.export.fail"));
      dispatch(setLoading(false));
    } finally {
      dispatch(setLoading(false));
    }
  };
  const handleDownload = async (payload: IFormExportValues) => {
    try {
      const { data } = await couponApi.exportCoupons({
        couponFamilyId: payload.couponFamilyId,
        startDate: payload.date?.[0] ? payload.date[0] : undefined,
        endDate: payload.date?.[1] ? payload.date[1] : undefined,
        active: payload.status?.includes('Active') ? 'active' : '',
        expired: payload.status?.includes('Expired') ? 'expired' : '',
        redeemed: payload.status?.includes('Redeemed') ? 'redeemed' : '',
      });
      const url = window.URL.createObjectURL(new Blob([data], { type: `text/csv` }));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "export redeem coupon");
      link.click();
      window.URL.revokeObjectURL(url);
      success(t("message.download.success"));
    } catch (err: any) {
      error(t("message.download.fail"));
      throw new Error(err);
    }
  };
  const button = (
    <Space>
      {mobile ? (
        <Tooltip title={t("page.add_new_coupon_family")}>
          <SharedIconButton type="primary" ghost icon={<PlusIcon />} onClick={goToCreate} />
        </Tooltip>
      ) : (
        <>
          <ExportSidebar data={data} handleExport={(params: IFormExportValues)=> handleDownload(params)} />
          <Tooltip title={t("page.add_new_coupon_family")}>
            <SharedButton
              type="primary"
              ghost
              icon={<PlusOutlined />}
              size="middle"
              onClick={goToCreate}
              >
              {t("page.add_cf")}
            </SharedButton>
          </Tooltip>
        </>
      )}
    </Space>
  );

  return (
    <>
      <ComponentHeader title={t("page.coupon_management")} />
      <StyledListPage>
        <StyledInnerListPage>
          <SearchFilter
            actionBtn={button}
            filter={couponFilter}
            callbackFun={changeFilter}
            searchText={searchText}
            searchInputPlaceholder={t("page.search_user_by")}
            selectedOption={filters}
          />
          {mobile && <Space direction="horizontal"><ExportSidebar data={data} handleExport={(params: IFormExportValues)=> handleDownload(params)} /></Space>}
          <SelectedFilter
            handleClearSearch={handleClearSearch} 
            selected={filters} 
            formDate={date[0]} 
            toDate={date[1]} 
          />
          <CouponTable data={data} callback={fetchCoupon} />
          <ComponentPagination total={total} page={page.page} changePage={handlePagination} />
        </StyledInnerListPage>
      </StyledListPage>
    </>
  );
};
